<template>
  <div class="va-row">
    <div class="flex md12 xs12 bank-account-filter">
      <vuestic-widget>
        <div class="va-row">
          <div class="flex md4">
            <div class="select-title">{{ $t("t.currency") }}</div>
            <el-select v-model="currencyFilter" filterable>
              <el-option :label="$t('basic.select.all')" value="null" selected />
              <el-option
                v-for="(val, index) in currencyOptions"
                :key="index"
                :label="val"
                :value="val"
              ></el-option>
            </el-select>
          </div>
          <div class="flex md4">
            <div class="select-title">{{ $t("t.status") }}</div>
            <el-select  v-model="statusFilter" filterable>
              <el-option :label="$t('basic.select.all')" value="null" selected />
              <el-option
                v-for="(val, index) in statusOptions"
                :key="index"
                :label="statusLabel(val)"
                :value="val"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="va-row mt-2">
          <div class="flex md8">
            <button class="btn btn-primary btn-sm mr-2" @click="searchOrder">
              <div class="btn-with-icon-content">
                <i class="ion-md-search ion"></i>
                {{ "basic.button.search" | translate }}
              </div>
            </button>
            <button class="btn btn-info btn-sm" @click="createBankAccount">
              <div class="btn-with-icon-content">
                <i class="ion-md-person-add ion"></i>
                {{ "basic.button.new" | translate }}
              </div>
            </button>
          </div>
        </div>
      </vuestic-widget>
    </div>

    <div class="flex xs12 md12 w-table">
      <vuestic-widget id="dategridPayOrder">
        <div class="table-responsive">
          <table class="table table-striped first-td-padding">
            <thead>
              <tr>
                <th v-for="(item, index) in tableHeaderList" :key="index">
                  {{ item.label | translate }}
                </th>
              </tr>
            </thead>
            <tbody v-if="list && list.length > 0">
              <tr v-for="(item, index) in list" :key="index">
                <td> {{ item.id }} </td>
                <!-- <td>{{ item.type }}</td> -->
                <td>{{ item.currency }}</td>
                <td>{{ item.account_number }}</td>
                <td>
                  <el-tag
                    effect="dark"
                    disable-transitions
                    :type="getStatusColor(item.status)"
                    >{{ statusLabel(item.status) }}</el-tag
                  >
                </td>
                <td>{{ item.create_time }}</td>
                <td>
                  <el-button @click="handleView(item)" type="info" size="small" style="padding: 9px 15px;">{{ $t("view") }}</el-button>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="13" v-text="noData"></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="block" v-if="isMobile === 'pc'">
          <pagination
            v-show="total > 0"
            :total="total"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :page.sync="page"
            :limit.sync="limit"
            @pagination="orderData"
          />
        </div>
        <div class="block" v-else>
          <pagination
            v-show="total > 0"
            :total="total"
            layout="total, prev, pager, next"
            background
            :page.sync="page"
            :limit.sync="limit"
            @pagination="orderData"
          />
        </div>
      </vuestic-widget>
    </div>
    <bank-account-create ref="bankAccountRefs" :bank-detail="bankDetail" @close="createBankClose" />
  </div>
</template>

<script>
import Scrollbar from "@/vuestic-theme/vuestic-components/vuestic-scrollbar/VuesticScrollbar.vue";
import Pagination from "@/components/Pagination";
import BankAccountCreate from "@/components/FinancialManagementNew/components/BankAccountCreate.vue"
import store from '@/store'

import { request } from "@/utils/utils.js";
let moment = require("moment-timezone");

export default {
  name: "BankAccounts",
  data() {
    return {
      tableHeaderList: [
        { label: "t.id", key: "id", id: 0 },
        // { label: "Type", key: "type", id: 1 },
        { label: "t.currency", key: "currency", id: 2 },
        // { label: "Name", key: "", id: 4 },
        // { label: "Bank Name", key: "", id: 5 },
        // { label: "Network", key: "", id: 6 },
        { label: "finance.account", key: "account_number", id: 4 },
        { label: "t.status", key: "status", id: 5 },
        { label: "tables.listing.recurring_create_time", key: "create_time", id: 6 },
        { label: "finance.operation", key: "operation", id: 7 },
        // { label: "tables.listing.updateTime", key: "updateTime", id: 13 },
      ],
      list: [],
      noData: this.$t("t.noDataNoOrder"),
      list: null, // 请求回来填充表格的数据
      total: 0, // 数据总条数
      page: 1, // 默认显示第1页
      limit: 10, // 默认一次显示10条数据
      bankDetail: {},
      networkOption: [],
      statusOptions: ['WAITING_APPROVE', 'APPROVED', 'FROZEN', 'REFUSED'],
      currencyFilter: 'null',
      statusFilter: 'null'
    }
  },
  components: {
    // VirtualAccountListFilter,
    Pagination,
    Scrollbar,
    BankAccountCreate
  },
  watch: {
    currTimeZone: function () {
      this.queryDate.start_time = moment
        .tz(moment.tz(this.dateVals[0], this.currTimeZone), "UTC")
        .format("YYYY-MM-DD HH:mm:ss");
      this.queryDate.end_time = moment
        .tz(moment.tz(this.dateVals[1], this.currTimeZone), "UTC")
        .format("YYYY-MM-DD HH:mm:ss");
    },
    dateVals: function (val) {
      this.queryDate.start_time = moment
        .tz(moment.tz(val[0], this.currTimeZone), "UTC")
        .format("YYYY-MM-DD HH:mm:ss");
      this.queryDate.end_time = moment
        .tz(moment.tz(val[1], this.currTimeZone), "UTC")
        .format("YYYY-MM-DD HH:mm:ss");
    },
  },
  created() {
    // this.dateVals.push(
    //   moment().subtract(31, "days").format("YYYY-MM-DD 00:00:00")
    // );
    // this.dateVals.push(moment().format("YYYY-MM-DD 23:59:59"));
    // this.queryDate.start_time = moment
    //   .tz(moment.tz(this.dateVals[0], this.currTimeZone), "UTC")
    //   .format("YYYY-MM-DD HH:mm:ss");
    // this.queryDate.end_time = moment
    //   .tz(moment.tz(this.dateVals[1], this.currTimeZone), "UTC")
    //   .format("YYYY-MM-DD HH:mm:ss");
    this.searchOrder();
  },
  mounted() {
    // this.getNetworkList()
    store.dispatch('datasource/GetBasicRegions')
  //   await this.initDropdown();
  },
  methods: {
    getStatusColor(status) {
      // 'WAITING_APPROVE', 'APPROVED', 'FROZEN', 'REFUSED'
      switch (status) {
        case "WAITING_APPROVE":
          return "info";
        case "APPROVED":
          return "success";
        case "FROZEN":
          return "danger";
        case "REFUSED":
          return "warning";
        default:
          return "info";
      }
    },
    statusLabel(status) {
      const keyMap = {
        WAITING_APPROVE: 'finance.bankStatus.waitingApprove',
        APPROVED: 'finance.bankStatus.approved',
        FROZEN: 'finance.bankStatus.frozen',
        REFUSED: 'finance.bankStatus.refused',
      }
      const key = keyMap[status]
      return key ? this.$t(key) : status
    },
    isMobile: function () {
      if (document.body.clientWidth && document.body.clientWidth < 750) {
        return "mobile";
      }
      return "pc";
    },
    orderData() {
      this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half");
      // let start = this.page;
      // let end = this.limit;
      let token = localStorage.getItem("Authorization");
      request({
        method: "post",
        url: `api/dashboard/merchant/assets/batch-withdraw/bank-all-list?access_token=${token}&currency=${this.currencyFilter}&status=${this.statusFilter}`
      })
        .then((res) => {
          if (!res) {
            this.searching.close();
            return;
          }
          const { code, data } = res.data
          if (code == 20000) {
            this.list = [];
            // this.total = 0;
            this.noData = this.$t("t.noData");
            setTimeout(() => {
              this.searching.close();
            }, 200);
            return;
          }
          this.list = data;
          // this.total = data.total;
          if (this.list.length === 0) {
            this.noData = this.$t("t.noData");
          }
          setTimeout(() => {
            this.searching.close();
          }, 800);
        })
        .catch((err) => {
          this.searching.close();
        });
    },
    searchOrder() {
      this.page = 1;
      this.orderData();
    },
    loadingFullScreen(controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    createBankAccount() {
      this.bankDetail = {}
      this.$refs.bankAccountRefs.init()
    },
    handleView(item) {
      const access_token = localStorage.getItem("Authorization")
      this.loadingFullScreen('viewLoading', 'loading', 'fa fa-hourglass-half')
			request({
				method: "get",
				url: `api/dashboard/merchant/assets/batch-withdraw/bank-detail?access_token=${access_token}&id=${item.id}`,
				headers: { "Content-Type": "application/json" }
			})
				.then(res => {
          this.viewLoading.close()
					let data = res.data;
					if (data.code !== '10000') {
						return;
					}
          this.bankDetail = data.data
          this.$refs.bankAccountRefs.init()
				})
				.catch(err => { this.viewLoading.close() });
    },
    createBankClose() {
      this.searchOrder()
    },
    // getNetworkList() {
    //   const that = this
    //   const access_token = localStorage.getItem("Authorization")
    //   that.loadingFullScreen('networkLoading', 'loading', 'fa fa-hourglass-half')
    //   request({
    //     method: "get",
    //     url: `api/dashboard/merchant/assets/network-list?access_token=${access_token}`,
    //     headers: {
    //       "Content-Type": "application/json"
    //     }
    //   }).then(res => {
    //     that.networkLoading.close()
    //     let { code, data, msg } = res.data;
    //     if (code === "10000") {
    //       this.networkOption = data.map(network => {
    //         return { label: network.name, value: network.code }
    //       })
    //     } else {
    //       that.$message({
    //         type: "error",
    //         duration: 5000,
    //         message: msg
    //       });
    //     }
    //   }).catch(err => { });
    // }
  },
  computed: {
    currencyOptions() {
      // if (store.state.datasource.basicRegions.currencies) {
      //   return store.state.datasource.basicRegions.currencies
      // }
      return ['USD','EUR']
    }
  }
}
</script>
<style lang="scss" scoped>
table {
  text-align: center;
}

.alink {
  color: $vue-green;
  text-decoration: underline;
}

@media only screen and (max-width: 750px) {
  .mobile-btn {
    padding: 0.5rem 0.2rem 0;
  }

  /deep/ .pagination-container {
    padding: 5px 4px 10px;
    .el-pagination__total {
      display: block;
      margin-right: 4px;
    }
    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      margin: 0 2px 0;
    }
  }

  /deep/ .pagination-container {
    padding: 5px 4px 10px;
    .el-pagination {
      padding: 0;
      text-align: center;
    }
    .el-pagination__total {
      display: block;
      margin-right: 4px;
    }
    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      margin: 0 1px 0;
    }
  }

  /deep/ .buyer {
    padding-left: 5px;
    width: auto !important;
  }

  #details {
    min-width: 600px;
  }
}
/deep/ .el-pagination {
  text-align: center;
}
/deep/ .recurring-children {
  width: 300px;
  padding: 10px 20px;
  max-height: 350px;
  overflow-y: scroll;
  margin-top: -12px;
  li {
    list-style: none;
    cursor: pointer;
    color: #4ae387;
    text-decoration: underline;
    margin: 8px 0;
  }
}
/deep/ .recurrings-payment-order {
  .modal-dialog {
    margin-top: 0.2vh !important;
  }
  .recurrings-detail-content {
    max-height: 420px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
}

/deep/ .el-dialog {
  margin-top: 0.2vh !important;
  width: 98%;
}
/deep/ .el-dialog__header {
  padding: 10px 10px 0 !important;
}
/deep/ .el-dialog__headerbtn {
  position: absolute;
  top: 0;
  right: 5px;
  font-size: 30px;
}
/deep/ .el-dialog__title {
  font-size: 1.375rem;
  font-weight: 600;
}
/deep/ .el-dialog__body {
  padding: 30px !important;
}

.bank-account-filter {
  .el-select {
      display: block;
      position: relative;
  }
}

</style>

